import React, { useState, useEffect } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import UserUserName from "./account_user_name";
import UserIRD from "./account_ird";
import UserPinCode from "./account_pin_code";
import PreferredName from "./account_referred";
import UserFirstName from "./account_first_name";
import UserLastName from "./account_last_name";
import UserAddress from "./account_address";
import UserDOB from "./account_dob";
import UserAdressSuburb from "./account_address_suburb";
import UserAdressCity from "./account_address_city";
import UserAdressState from "./account_address_state";
import UserAdressPostCode from "./account_address_post_code";
import { userSelector } from "../../../store/user/user.selector";
import { updateUserInfo } from "../../../store/user/user.action";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const resetData = (user, form) => {
  const dob = user?.dob ? moment(user?.dob,"DD/MM/YYYY") : moment();
  const values = {
    preferredName: user?.preferredName || "",
    pinCode: user?.pinCode || "",
    username: user?.username || "",
    ird: user?.ird || "",
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    address: user?.address || "",
    postCode: user?.postCode || "",
    state: user?.state || "",
    subUrb: user?.subUrb || "",
    city: user?.city || "",
    dob,
  };
  form.setFieldsValue(values);
};

const AccountFormInfo = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "account" });
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  // -------------------------- FUNCTION --------------------------

  const handleEdit = () => {
    resetData(user, form);
    setEdit(true);
  };

  const handleCancel = () => {
    resetData(user, form);
    setEdit(false);
  };

  const onSelectAddress = (values) => {
    console.log({ values });
    form.setFieldsValue(values);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    resetData(user, form);
  }, [user, form]);

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    const dob = moment(values?.dob, "DD/MM/YYYY").format("DD/MM/YYYY");
    const update = {
      ...values,
      dob,
    };
    setLoading(true);
    dispatch(
      updateUserInfo({ update }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Account Details successfully!");
          setEdit(false);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onFinishFailed = (error) => {};

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading || !edit;
    return (
      <Form
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        name="info_form"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserUserName disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserIRD disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserFirstName disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserLastName disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <PreferredName disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserPinCode disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserDOB disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserAddress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserAdressSuburb disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserAdressCity disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserAdressState disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserAdressPostCode disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderEditButton()}
            {renderSaveButton()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderEditButton = () => {
    if (!edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              type="primary"
              className="login-form-button form-button"
              loading={loading}
              onClick={() => handleEdit()}
            >
              {t("edit")}
            </Button>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const renderSaveButton = () => {
    if (edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              className="login-form-button form-button"
              disabled={loading}
              onClick={() => handleCancel()}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button form-button save"
                loading={loading}
              >
                {t("save")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

export default AccountFormInfo;
